export default __webpack_public_path__ + "static/media/building.05a48e48.svg";